 
import React from 'react';

const Profile = () => {
  return (
    <div className="profile-page">
      <h1>Profile</h1>
      <p>User profile will be here...</p>
    </div>
  );
};

export default Profile;